import { render, staticRenderFns } from "./AddPartyForm.vue?vue&type=template&id=b01df4f4&scoped=true"
import script from "./AddPartyForm.vue?vue&type=script&lang=ts"
export * from "./AddPartyForm.vue?vue&type=script&lang=ts"
import style0 from "./AddPartyForm.vue?vue&type=style&index=0&id=b01df4f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01df4f4",
  null
  
)

export default component.exports